import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { LandscapeBasicInfoOrganism } from '../../organisms';
import LandscapeBaseAddTemplate from '../../../templates/LandscapeBaseAddTemplate';
import { InsertInitiativeDTOV3 } from '../../../store/landscapeAPI/landscape/dto/request/insert-initiative.dto';
import { UpdateInitiativeDto } from '../../../store/landscapeAPI/landscape/dto/request/update-initiative-dto';

export interface LandscapeBasicInformationAddTemplateProps {
  callbackFn: (landscape: InsertInitiativeDTOV3 | UpdateInitiativeDto) => void;
}

const LandscapeBasicInformationAddTemplate: FC<
  LandscapeBasicInformationAddTemplateProps
> = ({ callbackFn }) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeBaseAddTemplate>
          <LandscapeBasicInfoOrganism
            landscape={undefined}
            isEdit={false}
            callbackFn={callbackFn}
          />
        </LandscapeBaseAddTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeBasicInformationAddTemplate;
